import React, { useRef, useEffect, useState } from "react";
import Konn3ctHeader from "../Header & Footer/Konn3ctHeader";
import App1 from "./Konn3ct 1";
import App2 from "./Konn3ct 2";
import App3 from "./Konn3ct 3";
import Footer from "../Header & Footer/kfooter";
import Events from "../Images/Konn3ct Images/calendar-04.png";
import NoteTaker from "../Images/Konn3ct Images/note-02.png";
import Scheduling from "../Images/Konn3ct Images/check-list.png";
import Reactions from "../Images/Konn3ct Images/smile.png";
import Bandwidth from "../Images/Konn3ct Images/internet-antenna-01.png";
import Audio from "../Images/Konn3ct Images/audio-wave-01.png";
import PlayBack from "../Images/Konn3ct Images/previous.png";
import Rooms from "../Images/Konn3ct Images/meeting-room.png";
import Doc from "../Images/Konn3ct Images/google-doc.png";
import eCinema from "../Images/Konn3ct Images/tv-smart.png";
import Polls from "../Images/Konn3ct Images/quiz-03.png";
import Highlights from "../Images/Konn3ct Images/ai-idea.png";
import Support from "../Images/Konn3ct Images/customer-support (1).png";
import Dashboard from "../Images/Konn3ct Images/dashboard-speed-02.png";
import Caption from "../Images/Konn3ct Images/closed-caption.png";
import Translate from "../Images/Konn3ct Images/translation.png";
import Donate from "../Images/Konn3ct Images/gift.png";
import AI from "../Images/Konn3ct Images/sparkles.png";

const features = [
  { name: "Meeting Summary", img: NoteTaker },
  { name: "Scheduling", img: Scheduling },
  { name: "Reactions", img: Reactions },
  { name: "Low Bandwidth", img: Bandwidth },
  { name: "Audio Boost", img: Audio },
  { name: "Playback", img: PlayBack },
  { name: "Rooms", img: Rooms },
  { name: "Live Caption", img: Caption },
  { name: "Translate", img: Translate },
  { name: "Donate", img: Donate },
  { name: "AI", img: AI },
  { name: "Doc", img: Doc },
  { name: "eCinema", img: eCinema },
  { name: "Events", img: Events },
  { name: "Polls", img: Polls },
  { name: "Transcriptions", img: Highlights },
  { name: "24/7 Support", img: Support },
  { name: "Dashboard", img: Dashboard },
];

const LandingPage = () => {
  const scrollRef = useRef(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    let scrollAmount = 0;
    const speed = 1;
    const tick = 20;

    const step = () => {
      if (!container || isHovered) return;
      scrollAmount += speed;
      if (scrollAmount >= container.scrollWidth / 2) {
        scrollAmount = 0;
        container.scrollLeft = 0;
      } else {
        container.scrollLeft = scrollAmount;
      }
    };

    const id = setInterval(step, tick);
    return () => clearInterval(id);
  }, [isHovered]);

  const duplicated = [...features, ...features];

  return (
    <div>
      <div className="w-full min-h-screen flex flex-col bg-gradient-to-b from-[#03173f] to-[#2657B0] text-white font-sans relative overflow-hidden pt-[80px] sm:pt-[80px] md:pt-[100px]" >
        {/* Background grid - safe, non-blocking */}
        <div
          className="absolute inset-0 z-0 pointer-events-none"
          style={{
            backgroundImage: `
              repeating-linear-gradient(to right, rgba(255,255,255,0.06) 0, rgba(255,255,255,0.06) 1px, transparent 1px, transparent 100px),
              repeating-linear-gradient(to bottom, rgba(255,255,255,0.06) 0, rgba(255,255,255,0.06) 1px, transparent 1px, transparent 100px)
            `,
          }}
        />
        <Konn3ctHeader />
        {/* HERO - now forced on top with highest z-index */}
        {/* <section className="relative text-center mt-11 px-4 sm:px-6 w-full z-20"> */}
          <section className="relative text-center mt-11 px-4 sm:px-6 w-full z-20">
          <h1 className="text-4xl sm:text-4xl md:text-5xl font-bold leading-tight">
            Smarter Meetings. <br /> Powered by AI.
          </h1>
          <p className="mt-4 text-sm sm:text-base max-w-2xl mx-auto">
            One intelligent platform for meetings, <br /> teamwork, and seamless communication.
          </p>

          <div className="mt-6 flex justify-center">
            <div className="relative w-64 sm:w-72">
              
              <input
                type="email"
                placeholder="Enter your email address"
                className="px-4 py-3 pr-28 w-full rounded-xl border-none text-black outline-none text-xs sm:text-sm shadow-md"
              />

              <button
                onClick={() => window.location.href = "https://dashboard.konn3ct.com/register"}
                className="absolute top-1/2 right-2 -translate-y-1/2 bg-[#34A853] font-medium text-white px-4 py-2 rounded-lg text-xs sm:text-sm hover:bg-green-600 transition cursor-pointer z-10"
              >
                Get started
              </button>
            </div>
          </div>
          <p className="text-xs sm:text-sm mt-2">Free Forever. No Credit Card.</p>
        </section>

        {/* Desktop features - lower z-index than hero */}
    {/* Desktop features - no more overlap with hero */}
<section className="hidden md:block relative mt-[-80px] mb-20 z-10">
  <div className="flex justify-center items-end gap-7 max-w-7xl mx-auto px-4">
    {/* Left */}
    <aside className="flex gap-4 md:gap-5 flex-wrap items-center justify-end">
      <div className="flex flex-col gap-4 ">
        {features.slice(0, 3).map((item) => (
          <FeatureBox key={item.name} {...item} />
        ))}
      </div>
      <div className="flex flex-col gap-4">
        {features.slice(3, 7).map((item) => (
          <FeatureBox key={item.name} {...item} />
        ))}
      </div>
    </aside>

    {/* Middle large boxes */}
    <div className="grid grid-cols-2 gap-4 w-full max-w-lg">
      {features.slice(7, 11).map((item) => (
        <FeatureBox key={item.name} {...item} large />
      ))}
    </div>

    {/* Right */}
    <aside className="flex gap-4 md:gap-5 flex-wrap items-center justify-start">
      <div className="flex flex-col gap-4">
        {features.slice(11, 15).map((item) => (
          <FeatureBox key={item.name} {...item} />
        ))}
      </div>
      <div className="flex flex-col gap-4">
        {features.slice(15).map((item) => (
          <FeatureBox key={item.name} {...item} />
        ))}
      </div>
    </aside>
  </div>
</section>

        {/* Mobile scrolling features */}
        <section className="md:hidden mt-8 px-3 z-10">
          <div
            ref={scrollRef}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            onTouchStart={() => setIsHovered(true)}
            onTouchEnd={() => setIsHovered(false)}
            className="w-full overflow-x-auto hide-scrollbar"
          >
            <div className="flex gap-3 items-center py-4 min-w-max">
              {duplicated.map((item, idx) => (
                <button
                  key={`${item.name}-${idx}`}
                  className="flex-shrink-0 flex flex-col items-center justify-center w-28 h-28 rounded-xl bg-white text-[#1A4699] shadow transition-transform hover:scale-105 active:scale-95"
                  aria-label={item.name}
                >
                  <img src={item.img} alt={item.name} className="w-8 h-8 mb-1 object-contain" />
                  <div className="text-[11px] text-center px-1">{item.name}</div>
                </button>
              ))}
            </div>
          </div>
        </section>
      </div>

      <div className="relative z-20 mt-4 md:mt-4 space-y-6 md:space-y-6">
        <App1 />
        <App2 />
        <App3 />
        <Footer />
      </div>
    </div>
  );
};

const FeatureBox = ({ name, img, large }) => (
  <div
    className={`bg-white text-[#1A4699] flex flex-col items-center justify-center rounded-lg shadow transition-transform hover:scale-105 hover:shadow-lg duration-300 ${
      large ? "h-[150px] sm:h-[180px] text-sm sm:text-lg font-semibold" : "w-28 h-28"
    }`}
  >
    <img src={img} alt={name} className="w-10 h-10 mb-2 object-contain" />
    <p className="font-medium text-xs md:text-base text-center px-2">{name}</p>
  </div>
);

export default LandingPage;